import { useOutletContext } from "react-router";
import { JSX } from "react";

import { CommonContext } from "../types";
import Clients from "../../Clients/clients";

const BrokerPartnerClients = (): JSX.Element => {
  const { brokerId } = useOutletContext<CommonContext>();

  return <Clients brokerId={brokerId} />;
};

export { BrokerPartnerClients };
